var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from "@reduxjs/toolkit";
var slice = createSlice({
    name: "jsmap",
    initialState: {
        mapVersion: null,
        svgList: null,
        momData: null,
        themeRule: null,
        floors: null,
        bubbles: [],
        showJSMAPDiscardModal: false,
        discardAllAnnotations: false,
        annotationPresent: false,
    },
    reducers: {
        setMapVersion: function (state, _a) {
            var payload = _a.payload;
            return __assign(__assign({}, state), { mapVersion: payload });
        },
        setMomData: function (state, _a) {
            var _b, _c;
            var payload = _a.payload;
            var floors = [];
            floors = (_c = (_b = payload === null || payload === void 0 ? void 0 : payload.momData) === null || _b === void 0 ? void 0 : _b.features) === null || _c === void 0 ? void 0 : _c.filter(function (f) { return f.momType === "indoor.Level"; });
            return __assign(__assign({}, state), { svgList: payload.svgList, themeRule: payload.themeRule, floors: floors, momData: payload.momData });
        },
        setBubbles: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { bubbles: payload }));
        },
        setShowJSMAPDiscardModal: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { showJSMAPDiscardModal: payload }));
        },
        setDiscardAllAnnotations: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { discardAllAnnotations: payload }));
        },
        setAnnotationPresent: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { annotationPresent: payload }));
        },
    },
});
export var setMapVersion = (_a = slice.actions, _a.setMapVersion), setMomData = _a.setMomData, setBubbles = _a.setBubbles, setShowJSMAPDiscardModal = _a.setShowJSMAPDiscardModal, setDiscardAllAnnotations = _a.setDiscardAllAnnotations, setAnnotationPresent = _a.setAnnotationPresent;
export default slice.reducer;
